import XLSX from 'xlsx';

export class CellWriters {
  static number = (ws, address, value) => {
    if (ws[address] == null) {
      ws[address] = {};
    }
    ws[address].v = value;
    ws[address].t = 'n';
  }
  static decimalNumber = (ws, address, value) => {
    CellWriters.number(ws, address, value);
    ws[address].z = '#,##0.00';
  }
  static text = (ws, address, value) => {
    if (ws[address] == null) {
      ws[address] = {};
    }
    ws[address].v = value;
    ws[address].t = 's';
  }
  static date = (ws, address, value, dateFormat = 'dd-mmm-yyy') => {
    if (ws[address] == null) {
      ws[address] = {};
    }
    ws[address].v = value;
    ws[address].t = 'd';
    ws[address].z = dateFormat;
  }
  static pct = (ws, address, value, { normalize = true } = {}) => {
    if (ws[address] == null) {
      ws[address] = {};
    }
    ws[address].v = (normalize) ? value / 100 : value;
    ws[address].t = 'n';
    ws[address].z = '0.00%';
  }
};

export default {
  exportTotalCashFlowToExcel(userName, settlementDate, runDate, scenario, portfolioName, dealType, matrix) {
    let data     = [
      ['UserName', userName],
      ['Portfolio Name', portfolioName],
      ['Deal Type', dealType],
      ['Settlement Date', settlementDate],
      ['Run Date', runDate.toLocaleDateString()],
      ['Run Time', runDate.toLocaleTimeString()],
      ['Scenario name', scenario ? scenario.ScenarioName : '-----'],
      ['Scenario vendor', scenario ? scenario.Vendor : '-----'],
      []
    ];
    data         = data.concat(matrix);
    let fileName = portfolioName + "_" + scenario.ScenarioName + "_" + dealType + ".csv";
    return this.exportToExcel(data, fileName)
  },

  exportMultiTotalCashflowsToExcel({
                                     userName,
                                     settlementDate,
                                     runDate,
                                     portfolioName,
                                     dataset: rawDataset,
                                     earlyCall
                                   }) {
    const date             = runDate.toLocaleDateString();
    const time             = runDate.toLocaleTimeString();
    const callMaturityText = earlyCall ? 'Call' : 'Maturity';
    const fileName         = `Scenario Totals ${portfolioName} ${callMaturityText}.xlsx`;
    const dataset          = rawDataset.map(({
                                               scenario,
                                               dealType,
                                               matrix,
                                               totalTotals
                                             }) => {
      let sumProjectedLosses = totalTotals ? totalTotals.CollateralLosses : null;

      let data = [
        ['UserName', userName],
        ['Portfolio Name', portfolioName],
        ['Deal Type', dealType],
        ['Settlement Date', settlementDate],
        ['Run Date', date],
        ['Run Time', time],
        ['Scenario name', scenario ? scenario.ScenarioName : '-----'],
        ['Scenario vendor', scenario ? scenario.Vendor : '-----'],
        ['Termination', callMaturityText],
        ['RefPoolLosses', sumProjectedLosses || ''],
        []
      ];
      data     = data.concat(matrix);

      return {
        name: scenario.ScenarioName,
        data
      }
    });

    return this.exportMultiTabsToExcel(dataset, fileName);
  },

  exportMultiTabsToExcel(dataset, fileName) {
    const wb = XLSX.utils.book_new();

    dataset.forEach(({
                       name,
                       data
                     }) => {
      wb.SheetNames.push(name);
      const cashflowSheet = XLSX.utils.aoa_to_sheet(data);
      wb.Sheets[name]     = cashflowSheet;
    });

    return XLSX.writeFile(wb, fileName);
  },

  exportToExcel(data, name) {
    let wb = XLSX.utils.book_new();
    wb.SheetNames.push("Cashflow");
    let cashflowSheet     = XLSX.utils.aoa_to_sheet(data);
    wb.Sheets["Cashflow"] = cashflowSheet;
    return XLSX.writeFile(wb, name);
  },

  exportCashflowToExcel(userName, dealName, bondName, settlementDate, runDate, scenario, matrix) {
    let data         = [
      ['UserName', userName],
      ['Deal Name', dealName],
      ['Bond Name', bondName || '-----'],
      ['Settlement Date', settlementDate],
      ['Run Date', runDate.toLocaleDateString()],
      ['Run Time', runDate.toLocaleTimeString()],
      ['Scenario name', scenario ? scenario.ScenarioName : '-----'],
      ['Scenario vendor', scenario ? scenario.Vendor : '-----'],
      []
    ]
    data             = data.concat(matrix)
    let workBookName = buildWorkBookName(dealName, bondName, scenario)
    return this.exportToExcel(data, workBookName);
  },
  // #####
  // region 48
  exportToXlsx(dataset = null, fileName = 'Default file name.xlsx') {
    /* Data Set Example
     if (!dataset) {
     dataset = [
     {
     'sheetName': 'Sheet Name',
     'sheetData': [
     ['Header 1', 'Header Value 1'],
     ['Header 2', 'Header Value 2'],
     ['Column 1', 'Column 2', 'Column 3'],
     ['Value 1', 'Value 2', 'Value 3'],
     ]
     }
     ];
     }
     */
    const wb = XLSX.utils.book_new();
    dataset.forEach(({
                       sheetName,
                       sheetData
                     }) => {
      wb.SheetNames.push(sheetName);
      const preparedValues = XLSX.utils.aoa_to_sheet(sheetData);
      wb.Sheets[sheetName] = preparedValues;
    });
    return XLSX.writeFile(wb, fileName);
  }
  // endregion 48
  // #####
}

function buildWorkBookName(dealName, bondName, scenario) {
  let workBookName = dealName

  if (bondName != null && bondName != "" && bondName != undefined) {
    workBookName += "_" + bondName
  }
  if (scenario != null && scenario != "" && scenario != undefined) {
    workBookName += "_" + scenario.ScenarioName + "_from_" + scenario.Vendor
  }

  workBookName += ".csv"

  return workBookName;
}
